/**
 * Mixed values: what a widget shows when several entities are selected and
 * their values differ, like Unreal's "Multiple Values". The Inspector passes
 * `MIXED` as the value (or inside a vec3, per axis); a widget shows a dash and
 * any edit sets one value on all of them.
 *
 * `MIXED` never reaches a command: the binding replaces any left in an edited
 * value with each entity's own before dispatching.
 */

export const MIXED: unique symbol = Symbol("mixed");

/** How a mixed value reads: a dash, as a placeholder or menu entry. */
export const MIXED_LABEL = "—";

/** The menu value of the dash entry; no real option uses it. */
export const MIXED_OPTION = "\u0000mixed";

export function isMixed(value: unknown): value is typeof MIXED {
  return value === MIXED;
}

/** The dash entry a menu selects while its value is mixed; it can't be chosen back. */
export function MixedOption({ mixed }: { readonly mixed: boolean }) {
  if (!mixed) return null;
  return (
    <option value={MIXED_OPTION} disabled>
      {MIXED_LABEL}
    </option>
  );
}

/** Sets a checkbox's indeterminate state, which has no HTML attribute. */
export function indeterminateRef(mixed: boolean) {
  return (input: HTMLInputElement | null) => {
    if (input) input.indeterminate = mixed;
  };
}
